var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "InvoicingProviderSettings",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    name: _vm.formName,
                    labelAlign: _vm.$config.forms.defaultLabelAlign,
                    id: _vm.formId
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpRow",
                    [
                      _c(
                        "ItpCol",
                        [
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "name",
                                label: _vm._f("pgettext")(
                                  "Name",
                                  "InvoicingProviderSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "font-weight-bold no-focus-border",
                                attrs: { plaintext: "" },
                                model: {
                                  value: _vm.settings.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "name", $$v)
                                  },
                                  expression: "settings.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "url",
                                label: _vm._f("pgettext")(
                                  "URL",
                                  "InvoicingProviderSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The root URL of the service.",
                                  "InvoicingProviderSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "url", required: "" },
                                model: {
                                  value: _vm.settings.url,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "url", $$v)
                                  },
                                  expression: "settings.url"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "invoice_prefix",
                                label: _vm._f("pgettext")(
                                  "Invoice prefix",
                                  "InvoicingProviderSettings"
                                ),
                                required: "",
                                helpTooltip: _vm._f("pgettext")(
                                  "The invoice prefix set up by the provider.",
                                  "InvoicingProviderSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "invoice_prefix", required: "" },
                                model: {
                                  value: _vm.settings.invoice_prefix,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "invoice_prefix",
                                      $$v
                                    )
                                  },
                                  expression: "settings.invoice_prefix"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "username",
                                label: _vm._f("pgettext")(
                                  "Username",
                                  "InvoicingProviderSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The technical user's name.",
                                  "InvoicingProviderSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "username", required: "" },
                                model: {
                                  value: _vm.settings.username,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "username", $$v)
                                  },
                                  expression: "settings.username"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "agent_key",
                                label: _vm._f("pgettext")(
                                  "Agent key",
                                  "InvoicingProviderSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The technical user's agent key.",
                                  "InvoicingProviderSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "agent_key", required: "" },
                                model: {
                                  value: _vm.settings.agent_key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "agent_key", $$v)
                                  },
                                  expression: "settings.agent_key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "invoice_template",
                                label: _vm._f("pgettext")(
                                  "Invoice template",
                                  "InvoicingProviderSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The ID/key of the invoice template.",
                                  "InvoicingProviderSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "invoice_template" },
                                model: {
                                  value: _vm.settings.invoice_template,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "invoice_template",
                                      $$v
                                    )
                                  },
                                  expression: "settings.invoice_template"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "invoice_notes",
                                label: _vm._f("pgettext")(
                                  "Invoice notes",
                                  "InvoicingProviderSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "General notes to append to all invoices.",
                                  "InvoicingProviderSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: { name: "invoice_notes" },
                                model: {
                                  value: _vm.settings.invoice_notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "invoice_notes", $$v)
                                  },
                                  expression: "settings.invoice_notes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "invoice_notes",
                                label: _vm._f("pgettext")(
                                  "Send email notifications",
                                  "InvoicingProviderSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "Send email notifications from the provider service.",
                                  "InvoicingProviderSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "send_email" },
                                model: {
                                  value: _vm.settings.send_email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.settings, "send_email", $$v)
                                  },
                                  expression: "settings.send_email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms[_vm.formName] && _vm.forms[_vm.formName].id,
                  text: _vm._f("pgettext")("Save", "Button"),
                  type: "submit",
                  variant: "primary",
                  default: "",
                  spinning: _vm.actions.submit && _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "Button"),
                  variant: "default",
                  disabled: _vm.actions.submit && _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }